































































































import { Vue, Component, Prop } from "vue-property-decorator";

// Enums
import { ProductTypes } from "@/data/enums/products";

@Component({
  components: {
    "product-provider": () =>
      import("@/components/app/admin/catalogue/products/productProvider.vue"),
    "catalogue-breadcrumbs": () =>
      import(
        "@/components/app/admin/catalogue/products/productCatalogueBreadcrumbs.vue"
      ),
    "product-image-carousel": () =>
      import(
        "@/components/app/admin/catalogue/products/productImageCarousel.vue"
      )
  }
})
export default class ProductView extends Vue {
  public $refs!: {
    productProvider: HTMLFormElement;
  };

  // Props
  @Prop({ required: true })
  public productTypes!: ProductTypes[];

  public get routeHasError() {
    return this.$_.get(this.$refs, "productProvider.routeHasError", false);
  }

  public get hasMissingPrices() {
    return this.$_.get(this.$refs, "productProvider.hasMissingPrices", false);
  }

  public get canShowProvisioning() {
    return this.$_.get(
      this.$refs,
      "productProvider.canShowProvisioning",
      false
    );
  }

  public get canShowAutomation() {
    return this.$_.get(this.$refs, "productProvider.canShowAutomation", false);
  }

  public get productId() {
    return this.$route.params.productId;
  }

  public get guardFunctionalities() {
    return this.productTypes.includes(ProductTypes.PRODUCT_OPTION)
      ? ["staff_get_product", "list_product_options_categories"]
      : this.productTypes.includes(ProductTypes.PRODUCT_ATTRIBUTE)
      ? ["staff_get_product", "list_product_attributes_categories"]
      : ["staff_get_product", "list_product_categories"];
  }

  // Computed
  public get routes(): any[] {
    return this.$_.get(this, "$attrs.routes", () => [])(this);
  }
}
